module.exports = __webpack_public_path__ + "static/img/main-title6.79b6a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/main-title6.png
// module id = T/cT
// module chunks = 0